import { GLOBAL_FEATURE_KEYS, getCachedGlobalFeatureFlagsForSync, isGlobalFeatureOn } from '../../shell/feature-flags/globalFeatureFlagsService';
import { isOnline } from '../../shell/connectivity/connectivityInfra';
import { getSessionOrganizationId } from '../../shell/session/sessionOrganization';
import { captureCatch } from '../../shared/sentry/sentryUser';
import { pullCustomerDataFromSupabaseApplication } from './pullCustomersUseCase';

let pullInFlight: Promise<void> | null = null;
let lastPullAt = 0;

/** Pulls pasivos (mount/focus de pantallas, refresh de dominios): máx 1 por minuto. */
const PASSIVE_PULL_MIN_INTERVAL_MS = 60_000;

/**
 * Baja snapshot de clientes/customer solo si hay org, módulo habilitado y no hay otra corrida en vuelo.
 * `immediate: true` saltea el intervalo mínimo (ej. apertura de checkout POS, que muestra saldos).
 */
export async function pullCustomerDataWhenNeeded(opts?: { immediate?: boolean }): Promise<void> {
  if (pullInFlight) return pullInFlight;
  if (!opts?.immediate && Date.now() - lastPullAt < PASSIVE_PULL_MIN_INTERVAL_MS) return;

  pullInFlight = (async () => {
    if (!(await isOnline())) return;

    const orgId = await getSessionOrganizationId().catch(captureCatch('sync', 'pull-customer-org-lookup', null));
    if (!orgId) return;

    const flags = getCachedGlobalFeatureFlagsForSync();
    const customerModuleOn =
      flags === undefined ? true : isGlobalFeatureOn(flags ?? null, GLOBAL_FEATURE_KEYS.fiado_integrations);
    if (!customerModuleOn) {
      return;
    }

    await pullCustomerDataFromSupabaseApplication();
    lastPullAt = Date.now();
  })().finally(() => {
    pullInFlight = null;
  });

  return pullInFlight;
}

/** Test-only: resetea el throttle entre tests. */
export function resetCustomerPullThrottleForTests(): void {
  lastPullAt = 0;
}
